import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ProjectreportingReducer(state = initialState.projectreporting, action: any) {
  switch (action.type) {
    case types.SAVE_PROJECTREPORTING_SUCCESS:
      return action.projectreporting;
    default:
      return state;
  }
}
